<template>
  <AdminMachineModels :lockedFilters="{ MachineTypeIdList: [$route.params.typeId] }" hideMachineTypeFilter />
</template>


<script>
import AdminMachineModels from "@/views/pim/machinemodels/AdminMachineModels.vue";


export default {
  name: "ViewMachineTypeModelList",
  props: {},
  components: {
    AdminMachineModels,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>